// @ts-nocheck
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button';
import MarkdownView from '../../../components/MarkdownView/MarkdownView';
import VideoIcon from '../../../assets/icons/videoPlayIcon.svg';
import { useAsync } from 'react-use';
import { useEvent } from '../../../hooks/useEvent';
import { useAuthentication } from '../../../contexts/AuthContext';
import { useMemo } from 'react';

const EventContentOverview = () => {
  const navigate = useNavigate();
  const { selectedEvent } = useAuthentication();
  const { getEventByIdWithChallenges } = useEvent();
  const { value: eventDescription = [] } = useAsync(() =>
    getEventByIdWithChallenges(selectedEvent?._id), [selectedEvent]);

  const courseContent = eventDescription?.courseContent;
  const eventContentData = useMemo(() => {
    if (courseContent) {
      return courseContent;
    }
    return null;
  }, [courseContent]);

  return (
    <>
       <div className="text-indigo-600 text-xl font-semibold font-['Manrope'] mt-4">
        {eventContentData?.courseTitle}
      </div>
      <div className="self-stretch w-full text-black text-left text-opacity-75 text-base
        font-medium font-['Manrope'] overflow-scroll"
      >
        {eventContentData?.courseDescription && (
          <MarkdownView
            className="event-description ps-4 pt-3"
            linkTarget="_blank"
            value={eventContentData?.courseDescription}
          />
        )}
        {eventContentData?.otherDetails && (
          <>
            <div
              className="text-indigo-600 text-xl font-semibold font-['Manrope'] mt-4"
            >
              Other Details
            </div>
            <MarkdownView
              value={eventContentData?.otherDetails}
            />
          </>
        )}
      </div>
      <div className="self-stretch w-full text-black text-left text-opacity-75 text-base
        font-medium font-['Manrope'] overflow-scroll"
      >
        <h1 className="text-indigo-600 text-xl mb-6 border-b pb-2">
          Discover The Course Content
        </h1>
        {eventContentData?.content?.map((section, sectionIndex) => (
          <div key={section?.title} className="mb-8">
            {/* Section Header */}
            <div className="bg-gradient-to-r from-indigo-50 to-white border-l-4 border-indigo-500 px-4 py-2 rounded-md shadow-sm">
              <h2 className="text-indigo-800 tracking-wide">
                {section?.title}
              </h2>
            </div>
          
            {/* Section Items */}
            <div className="divide-y divide-gray-200 bg-white rounded-lg shadow-sm overflow-hidden">
              {section?.items.map((item, itemIndex) => (
                <div
                  key={`${sectionIndex}-${itemIndex}`}
                  className="flex items-center justify-between px-2 py-2 hover:bg-gray-50 transition-colors duration-200"
                >
                  <div className="flex items-center gap-3">
                    <img src={VideoIcon} alt="Video Icon" className="w-5 h-5 text-indigo-500" />
                    <div>
                      <h3 className="text-sm font-semibold text-gray-800">{item?.title}</h3>
                      {item?.duration && (
                        <p className="text-xs text-gray-500 mt-0.5">{item.duration}</p>
                      )}
                    </div>
                  </div>
          
                  <Button
                    type="button"
                    variant="primary-outline"
                    customClass="h-9"
                    onClick={() => {
                      navigate('/user/event-content');
                      window.localStorage.setItem('selectedVideo', JSON.stringify(item));
                    }}
                  >
                    <div className="text-indigo-600 text-sm font-semibold font-['Manrope'] tracking-wide">
                      Watch
                    </div>
                  </Button>
                </div>
              ))}
            </div>
          </div>      
        ))}
      </div>
      <div className="justify-start items-start gap-6 inline-flex text-left">
        <Button
          variant="primary"
          onClick={() => navigate('/user/event-content')}
        >
          <div className="text-white text-base font-bold font-['Manrope']">View Content</div>
        </Button>
      </div>
    </>
  );
};

export default EventContentOverview;
